import { Pipe, PipeTransform } from '@angular/core';
import { TipoMovimentacao } from 'src/app/core/models/movimentacao-cadastral/TipoMovimentacao';

@Pipe({
  name: 'tipoMovimentacao',
})
export class TipoMovimentacaoPipe implements PipeTransform {
  transform(tipo: TipoMovimentacao): string {
    const labels = {
      0: 'Inclusão',
      1: 'Alteração',
      2: 'Exclusão',
      3: 'Posição Cadastral',
      4: 'Pedido de Carga',
    };

    return labels[tipo];
  }
}
